<template>
  <div>
      <!-- <mheader></mheader> -->
      <div v-show="tableData.length>0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
             <p class="mt-2 font">
                <img src="../../static/images/kucun_1.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
               <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">

               近效期库存
               </span>
               <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>
             <p class="query mb-2 mt-2"><span  style="font-weight:600;">库存详细(凡是没有上传图片的药品，均不显示！双击药品名称或者生产厂家可以快速检索！)</span></p>
                   <div class="row ml-2 mb-2">
                     <div class="col-lg-6">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font hei" v-model="searchForm.ypmc" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        批号:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ph"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        生产厂家:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                 </div>

                             </div>

                          </div>

                       </div>
                        <div class="col-lg-6">
                          <div class="row ml-lg-5">
                                 <button class="bg-primary button_zi hei" style="width:20%;" @click="Search()">查询</button>

                      </div>
                  </div>
                </div>

           <table v-if="searchData.length>0"  class="table table-striped table-hover" ref="print">
               <thead>
                     <tr style="white-space: nowrap;">
                        <th>仓库</th>
                        <th>批号</th>
                        <th>药品名称</th>
                        <th>产地</th>
                        <th>规格</th>
                        <th>数量</th>

                        <th>零批价</th>
                        <th>批量价</th>
                        <th>有效期</th>
                        <th>入库日期</th>
                      </tr>
               </thead>
               <tbody>
                    <tr v-for="(item,index) in searchData" :key="index">
								<td>{{item.storeNo}}</td>
								<td>{{item.batchNum}}</td>
                              <td @dblclick="onInputdrugName(index)">{{item.drugName}}</td>
                              <td @dblclick="onInputcustomerName(index)">{{item.productFactory}}</td>
							  <td>{{item.spec}}</td>
                              <td>{{item.storeNum}}</td>

                              <td>{{item.retailPrice}}</td>
                              <td>{{item.wholePrice}}</td>
                              <td>{{item.dueDate}}</td>
                              <td>{{item.inStoreDate | formatUTC }}</td>
                  </tr>
               </tbody>

            </table>
            <table class="table table-striped table-hover" ref="print" v-else>
                    <thead>
                      <tr style="white-space: nowrap;">
					  <th>仓库</th>
                        <th>批号</th>
                         <th>药品名称</th>
                        <th>产地</th>
                        <th>规格</th>
                        <th>数量</th>

                        <th>零批价</th>
                        <th>批量价</th>
                        <th>有效期</th>
                        <th>入库日期</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index">
					   <td>{{item.storeNo}}</td>
								<td>{{item.batchNum}}</td>
                              <td @dblclick="onInputdrugName(index)">{{item.drugName}}</td>
                              <td @dblclick="onInputcustomerName(index)">{{item.productFactory}}</td>
							  <td>{{item.spec}}</td>
                              <td>{{item.storeNum}}</td>

                              <td>{{item.retailPrice}}</td>
                              <td>{{item.wholePrice}}</td>
                              <td>{{item.dueDate}}</td>
                              <td>{{item.inStoreDate | formatUTC }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 分页 -->
      <nav aria-label="Page navigation" style="text-align:center;" class="mb-1">
      <ul class="pagination">
        <li class="page-item ml-5" :class="PageNo<=1?'disabled':''" @click="prePage()">
          <a aria-label="Previous" class="page-link">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
           <li :class="index==PageNo?'active':''" class="page-item" v-for="index of Pcount" :key="index"
                                                @click="curPage(index)">
                                                <a class="page-link" v-if="index<=20">{{index}}</a>
                                                <a class="page-link" v-if="index>20 && index==(Pcount-1)">...</a>
                                                <a class="page-link" v-if="index>20 && index==Pcount">{{Pcount}}</a>
                                            </li>

        <li class="page-item" :class="PageNo>=Pcount?'disabled':''" @click="nextPage()">
          <a aria-label="Next" class="page-link" >
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
          <!-- <li class="ml-5">
            <span class="d-block mt-2">
              总共有
              <span style="color:green;font-size:20px">{{Record}}</span>
              条数据
            </span>
          </li> -->
      </ul>
    </nav>
      <p class="text-center">
        <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
      </p>
</div>


</div>        <!-- container -->




                <div v-show="Pcount===0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
             <p class="mt-2 font">
                <img src="../../static/images/kucun_1.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
               <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">

               近效期库存
               </span>
               <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>
             <p class="query mb-2 mt-2"><span  style="font-weight:600;">库存详细(凡是没有上传图片的药品，均不显示！双击药品名称或者生产厂家可以快速检索！)</span></p>
                   <div class="row ml-2 mb-2">
                     <div class="col-lg-6">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font hei" v-model="searchForm.ypmc" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        批号:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ph"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        生产厂家:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                 </div>

                             </div>

                          </div>

                       </div>
                        <div class="col-lg-6">
                          <div class="row ml-lg-5">
                                 <button class="bg-primary button_zi hei" style="width:20%;" @click="Search()">查询</button>

                      </div>
                  </div>
                </div>

              <img src="../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">
      <p class="text-center">
        <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
      </p>
</div>


</div>  


           
                <div>
                  <transition name="fade">
                           <loading v-if="isLoading"></loading>
                  </transition>
                </div>
  <!-- Footer -->
         <!-- <mfooter></mfooter> -->
     </div>
</template>
<script>
// import mheader from '../components/Header.vue'
// import mfooter from '../components/Footer.vue'
import Loading from '../components/Loading.vue'
export default {
      name: 'SaleQuery',
    data () {
      return {
          Height:0,
        searchForm: {
          ypmc: '',
          cdmc: '',
          ph: ''
        },//搜索内容
        searchData:[],//搜索返回的清单
        isLoading: false,
        tableData: [],
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1 //当前页码
      }
    },
    components:{
        // mheader,
        // mfooter,
        Loading
    },
    computed:{

},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
            return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
},

methods: {
  searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },
    //验证
        //  ypmc:function(){
        //       let reg1=/^[\u4e00-\u9fa5]{0,}$/;
        //        if(!reg1.test(this.searchForm.ypmc)){
        //              $("#ypmc").removeClass("d-none")
        //        }
        //        else{
        //             $("#ypmc").addClass("d-none")
        //        }
        //   },
        //   ph:function(){
        //        let reg2=/^[0-9]*$/;
        //        if(!reg2.test(this.searchForm.ph)){
        //              $("#ph").removeClass("d-none")
        //        }
        //        else{
        //             $("#ph").addClass("d-none")
        //        }
        //   },
        //   cdmc:function(){
        //         let reg3=/^[\u4e00-\u9fa5]{0,}$/;
        //         if(!reg3.test(this.searchForm.cdmc)){
        //              $("#cdmc").removeClass("d-none")
        //        }
        //        else{
        //              $("#cdmc").addClass("d-none")
        //        }
        //   },

    onInputdrugName:function(index){
          if(this.searchData.length>0){
            this.searchForm.ypmc=this.searchData[index].drugName;
          }
          else {
            this.searchForm.ypmc=this.tableData[index].drugName;
          }
      },
      onInputcustomerName:function(index){
          if(this.searchData.length>0)
          {
             this.searchForm.cdmc=this.searchData[index].productFactory
          }
          else
          {
            this.searchForm.cdmc=this.tableData[index].productFactory;
          }
      },

      getClerkNearlyGoods: async function (PageIndex) {
          this.PageNo=PageIndex || this.PageNo
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkNearlyGoods',
          obj: JSON.stringify({
             PageIndex,
             PageSize:20
          })
        })
        // console.log(res)
        if (res.isok) {
          const obj = res.data
          this.tableData = obj.rows
          this.Pcount = obj.pcount
          this.Record = obj.record
          // this.isLoading=false
        }
      },
      //搜索
        Search: async function (PageIndex) {

        const that = this

        that.PageNo = PageIndex || that.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'ClerkNearlyGoods',
          obj: JSON.stringify({
            PageIndex,
            PageSize: 20,
            DrugName: that.searchForm.ypmc.trim(),
            BatchNum: that.searchForm.ph.trim(),
            ProductFactory: that.searchForm.cdmc.trim(),
          })
        })
        // console.log(res)
        if(res.isok){
              const obj = res.data
              if(that.Pcount===0){
                      that.tableData = obj.rows
                   }
                   else{
                     that.searchData = obj.rows
                   }
              that.Pcount = obj.pcount
              that.Record = obj.record
              if(obj.pcount==0){
                alert('没有符合条件的信息')
                that.getClerkNearlyGoods(1);
              }

        }
        },
     curPage: function (index) {
         if(this.searchData.length>0){
            this.Search(index)
         }
         else{
           this.getClerkNearlyGoods(index)
         }
      },
      //上一页
      prePage: function () {
        if (this.PageNo > 1) {
          this.PageNo--;
           if(this.searchData.length>0){
            this.Search(this.PageNo)
          }
          else{

            this.getClerkNearlyGoods(this.PageNo);
          }
        }
      },
      //下一页
      nextPage: function () {
        if (this.PageNo < this.Pcount) {
          this.PageNo++;
          if(this.searchData.length>0){
            this.Search(this.PageNo)
          }
          else{

            this.getClerkNearlyGoods(this.PageNo);
          }
        }
      },
      //搜索功能

     // 打印
    start_print(){
        this.$print(this.$refs.print);//$refs的值要和html里的ref一致
    }

    },
    mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
     created () {
        this.getClerkNearlyGoods(1);



    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.hei{
  height:1.5rem;
}
.font_yz{
  font-size:1px;
  color:red;
}
 .button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .span_close:hover{
       color:#3190e8;
 }
</style>



// WEBPACK FOOTER //
// src/pages/NearlyGoods.vue